import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { baseUrl, userLocation, ipAddress, userName } from "../Univ.js";

function BOMPage() {

  const [rows, setRows] = useState([]);
  const [products, setProducts] = useState([]);

  const [data, setData] = useState({
    product: "",
    version: ""
  });

  useEffect(() => {
    fetchBOM();
    fetchProducts();
  }, []);

  const fetchBOM = () => {
    axios.get(baseUrl + "bom/")
      .then(res => {
        setRows(res.data);
      });
  };

  const fetchProducts = () => {
    axios.get(baseUrl + "products/")
      .then(res => {
        setProducts(res.data);
      });
  };

  const inputHandler = (e) => {
    setData({
      ...data,
      [e.target.name]: e.target.value
    });
  };

  const formSubmit = () => {

    if (!data.product) {
      Swal.fire("Error", "Product is required", "error");
      return;
    }

    const _formData = new FormData();
    _formData.append("product", data.product);
    _formData.append("version", data.version);
    _formData.append("status", "1");
    _formData.append("addedby", userName);
    _formData.append("ip_add", ipAddress);
    _formData.append("location", userLocation);

    axios.post(baseUrl + "bom/", _formData, {
      headers: { "Content-Type": "multipart/form-data" }
    })
    .then(response => {
      if (response.status === 200 || response.status === 201) {

        Swal.fire({
          title: "BOM Created",
          icon: "success",
          timer: 2000,
          showConfirmButton: false
        });

        setData({
          product: "",
          version: ""
        });

        fetchBOM();
      }
    })
    .catch(() => {
      Swal.fire("Error", "Something went wrong", "error");
    });
  };

  const handleDelete = (id) => {
    Swal.fire({
      title: "Confirm",
      text: "Are you sure you want to delete this?",
      icon: "warning",
      confirmButtonText: "Yes",
      showCancelButton: true
    }).then((result) => {
      if (result.isConfirmed) {
        axios.delete(baseUrl + "bom/" + id + "/")
          .then(() => {
            Swal.fire("Deleted", "BOM deleted", "success");
            fetchBOM();
          });
      }
    });
  };

  const columns = [
    { field: "id", headerName: "ID", width: 80 },
    {
      field: "product",
      headerName: "Product",
      flex: 1,
       renderCell: (params) => {
        if (params && params.row && params.row.product) {
          if (params.row.product !== null && params.row.product !== 0) {
            return params.row.product?.name;
          }
        }
        return 'Unknown';
      },
    },
    { field: "version", headerName: "Version", flex: 1 },
    {
      field: "edit",
      headerName: "Edit",
      renderCell: (params) => (
        <Link
          to={`/bom/edit/${params.row.id}`}
          target="_blank"
          className="btn btn-warning btn-sm"
        >
          Edit
        </Link>
      ),
      width: 120
    },
    {
      field: "delete",
      headerName: "Delete",
      renderCell: (params) => (
        <button
          onClick={() => handleDelete(params.row.id)}
          className="btn btn-danger btn-sm"
        >
          Delete
        </button>
      ),
      width: 120
    }
  ];

  return (
    <div className="container mt-4">

      {/* Form */}
      <div className="card p-4 mb-4">
        <h4>Add BOM</h4>

        <select
          className="form-control mt-3"
          name="product"
          value={data.product}
          onChange={inputHandler}
        >
          <option value="">Select Product</option>
          {products.map(prod => (
            <option key={prod.id} value={prod.id}>
              {prod.name}
            </option>
          ))}
        </select>

        <input
          type="text"
          className="form-control mt-3"
          placeholder="Version"
          name="version"
          value={data.version}
          onChange={inputHandler}
        />

        <button
          className="btn btn-success mt-3"
          onClick={formSubmit}
        >
          Submit
        </button>
      </div>

      {/* DataGrid */}
      <div className="card p-3">
        <DataGrid
          sx={{
            boxShadow: 4,
            border: 4,
            borderColor: "primary.light",
            "& .MuiDataGrid-cell:hover": {
              color: "primary.main",
            },
          }}
          rows={rows}
          columns={columns}
          pageSize={10}
          autoHeight
          components={{ Toolbar: GridToolbar }}
        />
      </div>

    </div>
  );
}

export default BOMPage;
